/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Ai_Catalog_GeneratingInputs */

const cs_property_ai_catalog_generating = /** @type {(inputs: Property_Ai_Catalog_GeneratingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generuji katalogové PDF…`)
};

const en_property_ai_catalog_generating = /** @type {(inputs: Property_Ai_Catalog_GeneratingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generating catalog PDF…`)
};

/**
* | output |
* | --- |
* | "Generating catalog PDF…" |
*
* @param {Property_Ai_Catalog_GeneratingInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_ai_catalog_generating = /** @type {((inputs?: Property_Ai_Catalog_GeneratingInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Ai_Catalog_GeneratingInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_ai_catalog_generating(inputs)
	return cs_property_ai_catalog_generating(inputs)
});